import { render, staticRenderFns } from "./PropositionsMercuComparative.vue?vue&type=template&id=45673881"
import script from "./PropositionsMercuComparative.vue?vue&type=script&lang=js"
export * from "./PropositionsMercuComparative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports